import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { HttpHeader } from '../core/httpheader';
import { API_URL, API_Signature } from '../core/apiconfig';
import { OnlineSignature } from './onlineSignature.model';
import { TxtAttach } from '../core/index.model';
import { Guid } from '../core/guid';

@Injectable()
export class OnlinesignatureService {
    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http,) {
        this.apiUrl = API_URL + API_Signature;
    }

    saveSignature(model: string): Promise<OnlineSignature> {
        let body = model; 
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + '/SaveSignature' , body, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as OnlineSignature)
            .catch(this.handleError);
    }

    getisValidSign(signatureID: any): Promise<OnlineSignature> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.get(this.apiUrl + '/IsValidSignatureRequest/' + signatureID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as OnlineSignature)
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }


}



// WEBPACK FOOTER //
// ./SignClient/app/online-sign-pad/onlinesignature.service.ts